import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ResourceStore } from './resource.store';
import { LangStore } from './lang.store';
import { PageStore } from './page.store';
import { SystemStore } from './system.store';
import { router } from '../config/router';

@Component
export class Store extends mixins(
	LangStore,
	PageStore,
	ResourceStore,
	SystemStore
) {
	initialized: boolean = false;

	async init() {
		await this.fetchTimeVersion();
		await this.fetchSettings();
		await this.fetchLang();
		await this.fetchComponentsPage();
		await this.fetchIsTouchDevice();

		this.initialized = true;
	}
}

export const store = new Store({router});
